import React from "react";
import GridItem from "../../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../../DMSHeader/DMSHeader";
import { useTranslation } from 'react-i18next';
import ViewedExecuteSopsForm from "./ViewedExecuteSopsForm";


const ViewedSopInstance = () => {
  const { t } = useTranslation();

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader title={t('viewed_execute_sops_formheader')}  
  />
      ),
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 14,
      id: 2,
      component: <ViewedExecuteSopsForm  />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ViewedSopInstance;
